import { render } from "./users-role.vue?vue&type=template&id=b0f1b72e&scoped=true"
import script from "./users-role.vue?vue&type=script&setup=true&lang=js"
export * from "./users-role.vue?vue&type=script&setup=true&lang=js"

import "./users-role.vue?vue&type=style&index=0&id=b0f1b72e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f1b72e"],['__file',"src/views/administration/users/users-role.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0f1b72e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0f1b72e', __exports__)) {
    api.reload('b0f1b72e', __exports__)
  }
  
  module.hot.accept("./users-role.vue?vue&type=template&id=b0f1b72e&scoped=true", () => {
    api.rerender('b0f1b72e', render)
  })

}


export default __exports__